import type { i18n } from "i18next";
import { jaJP, enUS } from "@mui/x-data-grid";

export const isJp = (i18n: i18n): boolean => {
  return i18n.language === "ja";
};

export const gridLang = (i18n: i18n) => {
  return isJp(i18n) ? jaJP : enUS;
};
